import React, { Component } from 'react';
import Select from '../../Part_Sample/Select';
import Top_Bar from '../../Part_Sample/Top_Bar';

export default class Language extends Component {
	constructor(props) {
		super(props);

		let lang = 'En';
		if (this.props.receiver.lang != null && this.props.receiver.lang != '') lang = this.props.receiver.lang;

		let language_list = this.props.receiver.getLanguageList();
		this.language_options = [];
		for (let i in language_list) {
			this.language_options.push(<option selected value={language_list[i].value}>{language_list[i].display}</option>);
		}

		this.state = {
			lang: lang,
		}
	}

	handlePrevious = () => {
		window.app.content_area.current.switch_content.current.handleShowBottomMenu();
		this.props.content_handler('System');
	}

	handleChangeLanguage = (val) => {
		this.setState({ lang: val });
	}

	handleRegister = () => {
		this.props.receiver.setLanguage({ lang: this.state.lang });
		this.handlePrevious();
	}

	render() {
		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
		}

		return (
			<div>
				<div style={main_content_style} className='slideInDown'>
					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString('lang')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
					/>

					<div style={{ background: 'white', borderRadius: 20, marginTop: 10, marginLeft: 20, padding: 10, width: this.props.width - 60, height: this.props.height - 200 }}>
						<div style={{ display: 'inline-block', width: this.props.width - 240 }}>
							<span>{this.props.receiver.getString('lang')}</span>
						</div>
						<Select
							style={{ display: 'inline-block' }}
							select_style={{ width: 170, fontSize: 20, height: 40 }}
							options={this.language_options}
							value={this.state.lang}
							onSelect={this.handleChangeLanguage}
						/>
					</div>
				</div>
			</div>
		)
	}
}